/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Batch_Selected_HintInputs */

const en_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a subtitle preset and export all selected projects.`)
};

const fr_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un préréglage de sous-titres et exportez tous les projets sélectionnés.`)
};

const de_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Untertitelvoreinstellung und exportieren Sie alle ausgewählten Projekte.`)
};

const it_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un preset per i sottotitoli ed esporta tutti i progetti selezionati.`)
};

const ru_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предустановленный набор субтитров и экспортируйте все выбранные проекты.`)
};

const es_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un ajuste preestablecido de subtítulos y exporte todos los proyectos seleccionados.`)
};

const zh_cn2_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择字幕预设并导出所有选定的项目。`)
};

const ja_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕プリセットを選択し、選択したすべてのプロジェクトをエクスポートします。`)
};

const hi_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबटाइटल प्रीसेट चुनें और सभी चयनित प्रोजेक्ट्स को एक्सपोर्ट करें।`)
};

const pt_pt2_explorer_info_batch_selected_hint = /** @type {(inputs: Explorer_Info_Batch_Selected_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma predefinição de legendas e exporte todos os projetos selecionados.`)
};

/**
* | output |
* | --- |
* | "Choose a subtitle preset and export all selected projects." |
*
* @param {Explorer_Info_Batch_Selected_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_batch_selected_hint = /** @type {((inputs?: Explorer_Info_Batch_Selected_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Batch_Selected_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_batch_selected_hint(inputs)
	if (locale === "de") return de_explorer_info_batch_selected_hint(inputs)
	if (locale === "it") return it_explorer_info_batch_selected_hint(inputs)
	if (locale === "ru") return ru_explorer_info_batch_selected_hint(inputs)
	if (locale === "es") return es_explorer_info_batch_selected_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_batch_selected_hint(inputs)
	if (locale === "ja") return ja_explorer_info_batch_selected_hint(inputs)
	if (locale === "hi") return hi_explorer_info_batch_selected_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_batch_selected_hint(inputs)
	return en_explorer_info_batch_selected_hint(inputs)
});